import LoginRegisterBg from "./login-register-bg.jpg";
import LogoIcon from "./sproutit-logo-icon.png";
import Logo from "./sproutit-logo.png";
import EandBLogo from "./eandb-logo.png";
import Composting from "./composting.png";
import Bagging from "./bagging.png";
import Sterilizing from "./sterilizing.png";
import Inoculation from "./inoculation.png";
import Fruiting from "./fruiting.png";
import PreProductionOverview from "./pre-production-overview.png";
import CompostingOverview from "./composting-overview.png";
import BaggingOverview from "./bagging-overview.png";
import SterilizationOverview from "./sterilization-overview.png";
import InoculationOverview from "./inoculation-overview.png";
import FruitingOverview from "./fruiting-overview.png";
import PostProductionOverview from "./post-production-overview.png";
import MushroomProductionOverview from "./mushroom-production-overview.png";
import OysterMushroomOverview from "./oyster-mushroom-overview.png";

import Green from "./indicators/green.svg";
import YellowGreen from "./indicators/yellowgreen.svg";
import Yellow from "./indicators/yellow.svg";
import Orange from "./indicators/orange.svg";
import Red from "./indicators/red.svg";

export const Images = {
  LoginRegisterBg,
  LogoIcon,
  Logo,
  EandBLogo,
  Composting,
  Bagging,
  Sterilizing,
  Inoculation,
  Fruiting,
  PreProductionOverview,
  CompostingOverview,
  BaggingOverview,
  SterilizationOverview,
  InoculationOverview,
  FruitingOverview,
  PostProductionOverview,
  MushroomProductionOverview,
  OysterMushroomOverview,

  Green,
  YellowGreen,
  Yellow,
  Orange,
  Red,
};
